import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@core/store';

export type BulkDeleteJobStatus = 'deleting' | 'success' | 'error';

export type BulkDeleteScope = 'group' | 'branch';

export interface BulkDeleteJob {
  id: string;
  count: number;
  level: BulkDeleteScope;
  status: BulkDeleteJobStatus;
}

export interface AddBulkDeleteJobPayload {
  id: string;
  count: number;
  level: BulkDeleteScope;
}

export interface UpdateBulkDeleteJobStatusPayload {
  id: string;
  status: BulkDeleteJobStatus;
}

const initialState = {
  jobs: [] as BulkDeleteJob[]
};

export const bulkDeleteSlice = createSlice({
  name: 'bulkDelete',
  initialState,
  reducers: {
    addBulkDeleteJob: (
      state,
      action: PayloadAction<AddBulkDeleteJobPayload>
    ) => {
      state.jobs.push({ ...action.payload, status: 'deleting' });
    },
    updateBulkDeleteJobStatus: (
      state,
      action: PayloadAction<UpdateBulkDeleteJobStatusPayload>
    ) => {
      const job = state.jobs.find((item) => item.id === action.payload.id);
      if (job) {
        job.status = action.payload.status;
      }
    },
    removeBulkDeleteJob: (state, action: PayloadAction<string>) => {
      state.jobs = state.jobs.filter((item) => item.id !== action.payload);
    }
  }
});

export const {
  addBulkDeleteJob,
  updateBulkDeleteJobStatus,
  removeBulkDeleteJob
} = bulkDeleteSlice.actions;
export default bulkDeleteSlice.reducer;
export const selectBulkDeleteJobs = (state: RootState) => state.bulkDelete.jobs;
